import * as A from '@/domain/ui/actions';
import { UiStateFactory } from '@/domain/ui/helpers';
import { List } from 'immutable';

export const reducer = {
  ui(state = UiStateFactory(), action) {
    switch (action.type) {
      case A.toggleDocumentHotkeysModalAction.type:
        return state.setIn(
          ['modal', 'isOpenDocumentHotkeysModal'],
          !state.getIn(['modal', 'isOpenDocumentHotkeysModal']),
        );

      case A.toggleWorkspaceHotkeysModalAction.type:
        return state.updateIn(['modal', 'isOpenWorkspaceHotkeysModal'], (currentValue) => !currentValue);

      case A.toggleAFPanelAction.type:
        return state.setIn(['approvalFlow', 'isOpen'], action.payload);

      case A.setUiApprovalStampPositionAction.type:
        return state.setIn(['approvalFlow', 'stampPosition'], action.payload);

      case A.setUiWorkspaceContextMenuAction.type:
        return state.setIn(['workspace', 'isActiveContextMenu'], action.payload);

      case A.setUiSelectOpenAction.type:
        return state.setIn(['select', 'isOpen'], action.payload);

      case A.setUiDrawerOpenAction.type:
        return state.setIn(['drawer', 'isOpen'], action.payload);

      case A.addUiDeferredToastAction.type:
        return state.updateIn(['toast', 'deferred'], (l) => l.push(action.payload));

      case A.clearUiDeferredToastsAction.type:
        return state.setIn(['toast', 'deferred'], List());

      case A.setUiExtractedFieldsHighlightedAction.type:
        return state.setIn(['extractedFields', 'isHighlighted'], action.payload);

      case A.resetUiExtractedFieldsHighlightedAction.type:
        return state.setIn(['extractedFields', 'isHighlighted'], true);

      default:
        return state;
    }
  },
};
